import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';
import { DropdownListItem } from '@rsos/components/capstone/base/Dropdown/DropdownComponents';

export const RoleLimitReached = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})``;

export const DropdownListItemDisabled = styled(DropdownListItem)`
  cursor: default;
  opacity: 0.4;
`;
